import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { Breadcrumbs, Link as MuiLink, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { feedbackCall } from "../../redux/slice/feedback/feedback";

import "./Feedback.scss";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer2";
import Spinner from "../../component/spinner/Spinner";
// import worst from "../../assets/images/Worst.svg";
// import notgood from "../../assets/images/notgood.svg";
// import fine from "../../assets/images/fine.svg";
// import good from "../../assets/images/Good.svg";
// import excellent from "../../assets/images/excellent.svg";

const Feedback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    // feedbackData,
    loading,
    // success
  } = useSelector((state) => state.feedback);
  const [selectedEmoji, setSelectedEmoji] = useState(null); // State to track the selected emoji
  const [reason, setReason] = useState("");
  const [check, setCheck] = useState(false);
  const [error, setError] = useState(false);
  const { customerDetailsData } = useSelector((state) => state.customerDetails);

  let customerDetailsDataAlternative = localStorage.getItem("customerDetails");
  if (customerDetailsDataAlternative) {
    customerDetailsDataAlternative = JSON.parse(customerDetailsDataAlternative);
  } else {
    customerDetailsDataAlternative = {};
  }

  const handleEmojiClick = (emoji) => {
    setSelectedEmoji(emoji); // Update the state with the clicked emoji
  };

  const getEmojiClass = (emoji) => {
    return selectedEmoji === emoji ? "selected" : ""; // Return 'selected' class if the emoji is clicked
  };
  const user_name =
    Object?.keys(customerDetailsData || {})?.length > 0
      ? customerDetailsData?.firstname
      : customerDetailsDataAlternative?.firstname;

  const user_mobile =
    Object?.keys(customerDetailsData || {})?.length > 0
      ? customerDetailsData?.mobile
      : customerDetailsDataAlternative?.mobile;

  const handleSubmit = async (rating, reason) => {
    if (!selectedEmoji) {
      setError("Please Select a feedback emoji");
      return;
    }
    if (!reason) {
      setError("Please write a reason for your feedback");
      return;
    }
    if (!check) {
      setError("Please agree to our Privacy Policy");
      return;
    }
    setError("");

    const data = {
      root: {
        email: [
          {
            to: "avenuerewards@dlf.in,promenaderewards@dlf.in,cyberhubrewards@dlf.in,delhimallsrewards@dlf.in,loyalty-moi@dlf.in,mallofindiarewards@dlf.in,mtprewards@dlf.in",

            cc: "rewardscare@dlf.in",

            subject: "Feedback",
            body: `<!DOCTYPE html>\n<html>\n<head>\n  <meta charset="UTF-8">\n  <meta name="viewport" content="width=device-width, initial-scale=1.0">\n  <title>Feedback Received</title>\n  <style>\n    body {\n      font-family: Arial, sans-serif;\n      background-color: #f8f8f8;\n      margin: 0;\n      padding: 0;\n    }\n    table {\n      width: 100%;\n      border-collapse: collapse;\n      margin-top: 20px;\n    }\n    td {\n      padding: 5px 0;\n      vertical-align: top;\n    }\n    td.label {\n      font-weight: bold;\n      width: 120px;\n      color: #333333;\n    }\n    td.value {\n      color: #555555;\n    }\n  </style>\n</head>\n<body>\n  <div class="email-container">\n    <table>\n      <tr>\n        <td class="label">User Name:</td>\n        <td class="value">${user_name}</td>\n      </tr>\n      <tr>\n        <td class="label">User Mobile:</td>\n        <td class="value">${user_mobile}</td>\n      </tr>\n      <tr>\n        <td class="label">Rating:</td>\n        <td class="value">${rating}</td>\n      </tr>\n      <tr>\n        <td class="label">Feedback:</td>\n        <td class="value">${reason}</td>\n      </tr>\n    </table>\n  </div>\n</body>\n</html>\n`,
          },
        ],
      },
    };

    const result = await dispatch(feedbackCall({ data }));
    if (result?.payload?.status?.success) {
      toast.success("Feedback submitted successfully");
      setSelectedEmoji(null);
      setReason("");
      setCheck(false);
    } else {
      toast.error(result?.payload?.status?.message);
      setSelectedEmoji(null);
      setReason("");
      setCheck(false);
    }
  };

  const breadcrumbsMobile = [
    <MuiLink
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </MuiLink>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      Feedback
    </Typography>,
  ];
  return (
    <div>
      <Header />
      <div className="feedbackpage">
        <div
          className="container pt-5 in-mobile mobile_content"
          style={{
            position: "absolute",
            top: "20px",
            left: "16px",
            width: "90%",
          }}
        >
          <Breadcrumbs
            separator={
              <NavigateNextIcon fontSize="small" sx={{ color: "#A9A9A9" }} />
            }
            aria-label="breadcrumb"
          >
            {breadcrumbsMobile}
          </Breadcrumbs>
        </div>
        <div className="home-bg">
          <div className="heading">
            <p className="redtext">Feedback</p>
            <h1 className="feedbacktext">Leave a Review of your experience</h1>
            <div className="emojisection">
              <div
                className={`worstemoji ${getEmojiClass("worst")}`}
                onClick={() => handleEmojiClick("worst")}
              >
                <p>&#128534;</p>
                <p className="emojitext">Worst</p>
              </div>
              <div
                className={`notgoodemoji ${getEmojiClass("not good")}`}
                onClick={() => handleEmojiClick("not good")}
              >
                <p>&#128543;</p>
                <p className="emojitext">Not Good</p>
              </div>
              <div
                className={`fineemoji ${getEmojiClass("fine")}`}
                onClick={() => handleEmojiClick("fine")}
              >
                <p>&#128528;</p>
                <p className="emojitext">Fine</p>
              </div>
              <div
                className={`goodemoji ${getEmojiClass("good")}`}
                onClick={() => handleEmojiClick("good")}
              >
                <p> &#128512;</p>
                <p className="emojitext">Good</p>
              </div>
              <div
                className={`excellentemoji ${getEmojiClass("excellent")}`}
                onClick={() => handleEmojiClick("excellent")}
              >
                <p>&#128525;</p>
                <p className="emojitext">Excellent</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="feedback-content">
        <div className="feedback-sec">
          <p className="reason">Any reason for this feedback*</p>
          <p>
            <textarea
              className="textbox"
              placeholder="Write your query here"
              onChange={(e) => {
                setReason(e.target.value);
              }}
              value={reason}
            />
          </p>
          <div className="form-check_1">
            <label className="form-check-label" htmlFor="flexCheckDefault">
              <input
                className="form-check-input"
                type="checkbox"
                checked={check}
                id="flexCheckDefault"
                onChange={(e) => {
                  setCheck(e.target.checked);
                }}
              />
              By clicking the "Submit Details" button above, you agree to our
              <Link to="/privacy-policy" className="privacylink">
                {" "}
                Privacy & Policy
              </Link>
            </label>
            <span style={{ color: "#DB4B41", fontSize: "12px" }}>{error}</span>
            <button
              onClick={() => {
                handleSubmit(selectedEmoji, reason);
              }}
              style={{ display: "flex", justifyContent: "center" }}
            >
              Share Feedback {loading ? <Spinner /> : null}
            </button>
          </div>
        </div>
      </div>

      <Footer selected="feedback" />
    </div>
  );
};

export default Feedback;
